export function Logo() {
    return (
        <div className="flex flex-col items-center">
            <div className="relative w-64 h-36 md:w-80 md:h-44 flex items-center justify-center">
                <img
                    src="/gabanLogo.svg"
                    alt="El Gabán Logo"
                    className="w-full h-full object-contain"
                />
            </div>
        </div>
    )
}

